import type { CourseBrief } from "@/api/types";
import { courseColor } from "@/lib/course-colors";
import { cn } from "@/lib/utils";

/** Course identity: the course code as a small mono chip tinted with the course color. */
export function CourseChip({ course, className }: { course: Pick<CourseBrief, "code" | "color">; className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex w-fit shrink-0 items-center rounded-sm px-1.5 py-0.5 font-mono text-[10px] leading-3.5 whitespace-nowrap",
        courseColor(course.color).soft,
        className,
      )}
    >
      {course.code}
    </span>
  );
}
